import { DriverSafetyTranslations } from "./driverSafety/helpers/translations";
import { PasswordChangeTranslations } from "./core/settings/passwordChange/helpers/translations";
import { MessageTranslations } from "./messaging/helpers/translations";
import { EldMalfunctionsTranslations } from "./hos/eldMalfunctions/helpers/translations";
import { EventsTranslations } from "./core/notifications/events/helpers/translations";
import { SettingsTranslations } from "./core/settings/helpers/translations";
import { AddLogTranslations } from "./hos/addLog/helpersFunctions/translations";
import { HomeTerminalTranslations } from "./core/settings/helpers/homeTerminalTranslations";
import { ReportsTranslations } from "./hos/roadsideCheck/helpers/translations";
import { TripsTranslations } from "./trips/helpers/translations";
import { DashboardTranslations } from "./dashboard/helpers/translations";
import { LockscreenTranslations } from "./hos/lockscreen/helpers/translations";
import { HosMainTranslations } from "./hos/hosMain/helpers/translations";
import { InspectionsTranslations } from "./inspections/helpers/translations";
import { LoginTranslations } from "./core/auth/helpers/translations";
import { LogoutTranslations } from "./logout/helpers/translations";
import { ColdChainTranslations } from "./coldChain/helpers/translations";
import { CoachingTranslations } from "./coaching/helpers/translations";

/**
 * Add all translations for drive modules here.
 * All module translations are fetched at app start and are not lazy loaded.
 */
const TRANSLATIONS = DriverSafetyTranslations
    .concat(EventsTranslations)
    .concat(PasswordChangeTranslations)
    .concat(AddLogTranslations)
    .concat(MessageTranslations)
    .concat(EldMalfunctionsTranslations)
    .concat(SettingsTranslations)
    .concat(HomeTerminalTranslations)
    .concat(ReportsTranslations)
    .concat(TripsTranslations)
    .concat(DashboardTranslations)
    .concat(LockscreenTranslations)
    .concat(HosMainTranslations)
    .concat(InspectionsTranslations)
    .concat(LoginTranslations)
    .concat(LogoutTranslations)
    .concat(ColdChainTranslations)
    .concat(CoachingTranslations);

export default TRANSLATIONS;
